// extracted by mini-css-extract-plugin
export default {"predictiveModel":"components_predictiveModel__CoEP-","ItemAdvantages":"components_ItemAdvantages__fJBGD"};